import { on } from '@src/utils';
import { KEY_CODES } from '@src/utils/constants';

class Menu {
  constructor(classname) {
    this.classname = classname;

    this.body = document.querySelector('body');
    this.sidebar = document.querySelector('.js-sidebar');
    this.sidebarLogo = this.sidebar.querySelector('.js-sidebar-logo');
    this.sidebarNote = this.sidebar.querySelector('.sidebar-note');

    // On pages with a sidebarNote, the sidebarPromo remains visible when the
    // menu opens.  It shouldn't.
    this.sidebarPromo = this.sidebar.querySelector('.sidebar__footer-promo');

    this.menu = document.querySelector(`${this.classname}`);
    this.menuToggle = document.querySelector(`${this.classname}-toggle`);
    this.menuToggleText = document.querySelector(`${this.classname}-toggle-text`);
    this.menuIsOpen = false;

    // Could this be parameterized like the "this.classname"?
    // Is that necessary?  page-body is in base.twig, so it should be in every page.
    this.outsideTheMenu = document.querySelector('.menu-overlay');

    // Track content items
    this.menuItems = Array.from(document.querySelectorAll(`${this.classname}-item`));
    this.menuContentItems = Array.from(document.querySelectorAll(`${this.classname}-content`));
    this.DEFAULT_CONTENT_ID = this.menuItems.reduce(
      (acc, menuItem) => acc || menuItem.dataset.show,
      '',
    );

    this.listeners = [];

    this.republishBodyActiveClass = 'republish-modal-open';
    this.republishIsOpen = false;
    this.republishCloseButton = document.querySelector('.js-republisher .js-close-republisher');

    this.mobilereg = document.querySelector('.mobile-reg-button');

    this.querylyIcon = document.querySelector('.queryly_search_button') || false;

    this.bindEvents();
  }

  /**
   * Returns the classname without the starting `.`
   *
   * @example
   * this.classname = '.js--menu';
   * // this.plainClassname === 'js--menu'
   */
  get plainClassname() {
    return this.classname.replace(/^\.*/g, '');
  }

  get activeClass() {
    return `${this.plainClassname}-active`;
  }

  get hasBeenOpenedClass() {
    return `${this.plainClassname}-has-been-opened`;
  }

  bindEvents() {
    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', () => this.toggle());
    }
    if (this.querylyIcon) {
      this.querylyIcon.addEventListener('click', () => this.close());
    }
  }

  showContent(contentId) {
    this.menuContentItems.forEach(contentItem => {
      const itemId = contentItem.dataset.id;
      contentItem.setAttribute('aria-hidden', itemId !== contentId);
    });
    this.menuItems.forEach(menuItem => {
      const showId = menuItem.dataset.show;
      menuItem.setAttribute('aria-selected', showId === contentId);
    });
  }

  open() {
    this.menuToggle.setAttribute('aria-expanded', true);
    this.menu.setAttribute('aria-hidden', false);
    this.body.classList.add(this.activeClass);
    this.body.classList.add(this.hasBeenOpenedClass);
    this.menuToggleText.textContent = 'Close Menu';
    this.menuIsOpen = true;
    this.menuToggle.focus();

    if (this.sidebarNote) {
      this.sidebarNote.classList.add('hide');
      this.sidebarPromo.classList.add('hide');
    }

    // hides mobile reg when menu is open
    if (document.querySelector('.summit__nav__items')) {
      this.mobilereg.classList.add('hide');
    }

    this.listeners.push(on(document, 'keydown', this.keydown.bind(this)));
    this.listeners.push(on(this.outsideTheMenu, 'click', this.close.bind(this)));

    this.showContent(this.DEFAULT_CONTENT_ID);

    this.menuItems.forEach(menuItem => {
      const contentId = menuItem.dataset.show;
      if (contentId) {
        this.listeners.push(
          on(menuItem, 'click', () => {
            this.showContent(contentId);
          }),
        );
      }
    });

    if (document.body.classList.contains(this.republishBodyActiveClass)) {
      this.republishIsOpen = true;
    }
  }

  close() {
    this.menuToggle.setAttribute('aria-expanded', false);
    this.menu.setAttribute('aria-hidden', true);

    this.body.classList.remove(this.activeClass);
    this.menuToggleText.textContent = 'Open Menu';
    this.menuToggle.focus();
    this.menuIsOpen = false;
    this.listeners.forEach(off => off());

    if (this.sidebarNote) {
      this.sidebarNote.classList.remove('hide');
      this.sidebarPromo.classList.remove('hide');
    }

    // hides mobile reg when menu is open
    if (document.querySelector('.summit__nav__items')) {
      this.mobilereg.classList.remove('hide');
    }

    // If republish modal was open, focus on the republish close button
    if (this.republishCloseButton) {
      this.republishCloseButton.focus();
    }
  }

  toggle() {
    if (this.menuIsOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  keydown(evt) {
    switch (evt.key) {
      case KEY_CODES.ESCAPE: {
        this.close();
        break;
      }

      default: {
        break;
      }
    }
  }
}

export default Menu;
